import React from 'react'
import styled from 'styled-components'
const VidLoopWrapper = styled.div`
    video {
        width: 100%;
    }
`
const VideoLoop = ({src, description, poster=""}) => {
    
    return (
        <VidLoopWrapper>
            <video autoPlay muted playsInline loop  poster={poster}>
                <source src={src} />    
            </video>
            {description && <span className="sr-only">Video Description: {description} </span>}
        </VidLoopWrapper>
    )
}

export default VideoLoop
